import {URLS, ROLES} from "@/constants";
import globalMethods from "@/globalMethods";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {
        companyData: {},
        availableCompanies: [],
    },
    mutations: {
        setCompanyId(state, newCompanyId) {
            state.companyData.token = newCompanyId;
            if (newCompanyId) {
                globalMethods.setCookie("companyId", newCompanyId, 86400);
            } else {
                globalMethods.deleteCookie("companyId");
            }
        },
        setAvailableCompanies(state, data) {
            state.availableCompanies = data;
        },
        setCompanyData(state, newCompanyData) {
            state.companyData = newCompanyData;
        },
        updateCompany(state, data) {
            state.companyData.name = data.name;
            state.companyData.official_name = data.official_name;
            state.companyData.main_currency = data.main_currency;
        },
        updateCharacteristics(state, data) {
            state.companyData.good_characteristics = data;
        },
        updateDiscountPolicy(state, data) {
            state.companyData.discount_policy = data;
        },
        increaseAmountOfTransactions(state) {
            const datetimePointForAmountOfTransactionObject = new Date(state.companyData.datetime_point_for_amount_of_transaction)
            datetimePointForAmountOfTransactionObject.setHours(0, 0, 0, 0);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (datetimePointForAmountOfTransactionObject.getTime() === today.getTime()) {
                state.companyData.amount_of_transaction_today += 1;
                state.companyData.datetime_point_for_amount_of_transaction = new Date().toString();
            } else {
                state.companyData.amount_of_transaction_today = 1;
                state.companyData.datetime_point_for_amount_of_transaction = new Date().toString();
            }
        },
    },
    actions: {
        async setCompanyId({commit}, companyId) {
            commit("setCompanyId", companyId);
        },
        async createCompany({commit, rootState}, data) {
            const {name, official_name, main_currency} = data;
            const url = URLS.MODEL.COMPANY.COMPANY_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: rootState.personalData.role || "founder",
                },
                credentials: "include",
                body: JSON.stringify({
                    name: name,
                    official_name: official_name,
                    main_currency: main_currency
                })
            };
            const successfulHandler = (data) => {
                commit("setCompanyData", data.data);
                commit("setCompanyId", data.data.token);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async getCompanyData({commit, state, rootState}) {
            const {personalData} = rootState;
            if (personalData.role === ROLES.STAFF && state.companyData?.token === null) {
                return {successfully: false, detail: "redirect_to_choose_role"};
            }

            const url = URLS.MODEL.COMPANY.COMPANY_URL;
            const options = {
                method: "GET",
                headers: {
                    companyId: state.companyData?.token,
                    role: personalData.role,
                },
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("setCompanyData", data.data);
                commit("setCompanyId", data.data.token);
                return {successfully: true};
            };
            const errorHandler = (data) => {
                return data;
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler, errorHandler: errorHandler});
        },
        async getAvailableCompanies({commit, rootState}) {
            const url = URLS.MODEL.COMPANY.COMPANIES_URL;
            const options = {
                method: "GET",
                headers: {
                    role: rootState.personalData.role,
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("setAvailableCompanies", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateCompany({commit, state, rootState}, data) {
            const {personalData} = rootState;
            const {name, official_name, main_currency, recalculate_client_discount} = data;
            const url = URLS.MODEL.COMPANY.COMPANY_URL;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    companyId: state.companyData?.token,
                    role: personalData.role,
                },
                credentials: "include",
                body: JSON.stringify({
                    name: name,
                    official_name: official_name,
                    main_currency: main_currency,
                    recalculate_client_discount: recalculate_client_discount,
                    saleWithZeroRemainingIsAvailable: false,
                })
            };
            const successfulHandler = () => {
                notify(i18n.global.t("Company information has been successfully updated"));
                commit("updateCompany", {name: name, official_name: official_name, main_currency: main_currency});
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateCharacteristics({ commit, state, rootState }, data) {
            const {personalData} = rootState;
            const url = URLS.MODEL.COMPANY.CHARACTERISTICS_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: state.companyData?.token,
                },
                credentials: "include",
                body: JSON.stringify(data),
            };
            const successfulHandler = (data) => {
                commit("updateCharacteristics", data.data);
                notify(i18n.global.t("Specifications have been successfully updated"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateDiscountPolicy({commit, state, rootState}, data) {
            const {personalData, cashRegister} = rootState;
            const url = URLS.MODEL.COMPANY.COMPANY_DISCOUNT_POLICY_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: state.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                body: JSON.stringify(data),
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("updateDiscountPolicy", data.data);
                notify(i18n.global.t("The discount policy has been successfully updated"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};